module.exports = __webpack_public_path__ + "../../dist/frontend-shortcode-search/assets/fonts/primeicons.ttf";